import request from "@/request";

export async function getBlogPosts () {
  const res = await request({
    url: '/blog/posts',
    method: 'get'
  })

  return res.data
}